import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./style";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Dashboard } from "./modules/dashboard";
import { Login } from "./modules/login";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import { createTheme } from "./theme";
import { Documents } from "./modules/documents";
import { useContext } from "react";
import { AuthContext, AuthProvider } from "./contexts/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FetchProvider } from "./contexts/FetchContext";
import Acceptance from "./modules/acceptance";
import Dispatch from "./modules/dispatch";
import { Verify } from "./modules/verify";
import VerifyProducts from "./modules/verify/products";
import VerifySerialNumbers from "./modules/verify/serialNumbers";
import ResetPassword from "./modules/recovery";
import InventoryView from "./modules/verify/inventory";
import { InventoryProvider } from "./contexts/InventoryContext";
import { SoundProvider } from "./contexts/SoundContext";
import Locations from "./modules/verify/locations";
import MovementLog from "./modules/verify/movementLog";
import RoyaltyComponent from "./modules/verify/royaltys";
import Relocate from "./modules/relocate";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const theme = createTheme();

const PrivateRoute = () => {
  const { isLoggedIn } = useContext(AuthContext);
  const isAuthorized = isLoggedIn();

  return isAuthorized ? <Outlet /> : <Navigate to="/login" />;
};
root.render(
  <ThemeProvider theme={theme}>
    <SoundProvider>
      <AuthProvider>
        <FetchProvider>
          <BrowserRouter>
            <Routes>
              <Route path="login" element={<Login />} />
              <Route path="/auth/reset-password" element={<ResetPassword />} />

              <Route path="/" element={<App />}>
                <Route path="/" element={<PrivateRoute />}>
                  <Route path="/documents" element={<Documents />} />
                  <Route path="/acceptance" element={<Acceptance />} />
                  <Route index path="/" element={<Dashboard />} />
                  <Route path="/dispatch" element={<Dispatch />} />

                  <Route
                    path="/verify/royalty"
                    element={<RoyaltyComponent />}
                  />
                  <Route path="/verify/locations" element={<Locations />} />
                  <Route path="/verify" element={<Verify />} />
                  <Route path="/verify/products" element={<VerifyProducts />} />
                  <Route
                    path="/verify/serialNumbers"
                    element={<VerifySerialNumbers />}
                  />
                  <Route
                    path="/verify/inventory"
                    element={
                      <InventoryProvider>
                        <InventoryView />
                      </InventoryProvider>
                    }
                  />
                  <Route
                    path="/verify/movement-log"
                    element={<MovementLog />}
                  />
                  {/* Pagina nascosta: non linkata in alcun menu, raggiungibile solo via URL diretto */}
                  <Route path="/ricollocazione" element={<Relocate />} />
                </Route>
              </Route>
            </Routes>
            <ToastContainer
              theme="colored"
              style={{ maxWidth: "370px", margin: 10 }}
            />
          </BrowserRouter>
        </FetchProvider>
      </AuthProvider>
    </SoundProvider>
  </ThemeProvider>
);

reportWebVitals();
